<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-card :loading="loading" class="pa-2 rounded-lg ma-md-4" flat>
        <v-card-title
          class="flex-md-nowrap text-break pa-0 pa-md-4 white"
          style="position: sticky; top: 58px; z-index: 10"
        >
          <span class="pb-2">
            {{ value === undefined ? $t("create") : $t("edit") }}
            {{ tempContent.title || tempContent.name }}
          </span>
          <v-spacer />
          <div class="rowinfo">
            <v-btn
              v-if="hasReturn"
              :loading="loading"
              class="mx-1"
              color="red"
              text
              @click="$emit('close')"
            >
              {{ $t("back") }}
              <v-icon right>mdi-close</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-add-edit-hasreturn`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('back')"
            />
            <v-btn
              :loading="loading"
              color="success"
              outlined
              @click="submitNewProduct"
            >
              {{ $t("save_changes") }}
              <v-icon right>mdi-chevron-left</v-icon>
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-submit-new-product`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('save_changes')"
            />
          </div>
        </v-card-title>

        <custom-popup
          v-model="openSetting"
          :cons="{ title: $t('buy_button_settings') }"
          hide-confirm
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-setting-btn-pay`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('buy_button_settings')"
            />
          </template>
          <v-card class="m-5 p-5">
            <call-to-action v-model="tempContent.btnSetting" />
          </v-card>
        </custom-popup>

        <v-card-text class="pa-0 pa-md-4">
          <custom-tabs
            v-if="
              $route.name !== 'qr.product.shop' &&
              $route.name !== 'qr.product.edit'
            "
            v-model="tabs"
            :tab-items="computedTabItems"
            grow
          >
            <template v-slot:helpinfo="{ tab }">
              <help-info
                v-if="tab && tab.value && tab.text"
                :element-name="`${serviceName}-${componentName}-${tab.value}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${tab.text}`"
              />
            </template>
            <template v-slot:staticItems>
              <v-tabs-items
                v-if="
                  $route.name !== 'qr.product.shop' &&
                  $route.name !== 'qr.product.edit'
                "
                v-model="tabs"
                class="mb-6"
                touchless
              >
                <v-tab-item>
                  <pic-selector
                    v-model="tempContent.gallery"
                    :edit-name="false"
                    bracket="128"
                    single
                  />
                </v-tab-item>

                <v-tab-item disabled>
                  <color-pallete
                    v-model="tempContent.color"
                    class="my-8"
                    @input="resetOther(tempContent, 'color')"
                  />
                </v-tab-item>
              </v-tabs-items>
            </template>
          </custom-tabs>

          <v-row no-gutters>
            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <v-text-field
                  v-model="tempContent.name"
                  :rules="[rules.notEmpty, rules.minLen]"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  :label="$t('title')"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-data-tempContent-name`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('title')"
                />
              </div>
            </v-col>
            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <price-input
                  v-model.number="tempContent.price"
                  class="mb-2"
                  dense
                  :label="$t('price')"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-tempContent-price`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('price')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <v-text-field
                  v-model.number="computedtempContentdiscount"
                  :append-icon="
                    tempContent.discount_type === 'price'
                      ? currencyIcon
                      : 'mdi-percent'
                  "
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  class="contentinfo"
                  :label="$t('discount')"
                  outlined
                  type="text"
                  :rules="discountRules"
                >
                  <template v-slot:append-outer>
                    <v-radio-group
                      v-model="tempContent.discount_type"
                      class="mb-0 pa-0 mt-n1"
                      dense
                      hide-details
                      mandatory
                    >
                      <v-radio :label="$t('percent')" value="percent" />
                      <v-radio :label="$t('amount')" value="price" />
                    </v-radio-group>
                  </template>
                </v-text-field>
                <help-info
                  :element-name="`${serviceName}-${componentName}-tempContent-discount`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('discount')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <v-text-field
                  v-model="tempContent.brand"
                  clear-icon="mdi-close-circle-outline"
                  class="contentinfo"
                  clearable
                  dense
                  :label="$t('brand')"
                  outlined
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-tempContent-brand`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('brand')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <v-text-field
                  v-model="tempContent.inventory"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  :hint="$t('inventory_hint')"
                  :label="$t('inventory')"
                  outlined
                  type="number"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-tempContent-inventory`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('inventory')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <v-text-field
                  v-model="tempContent.order_limit"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  :hint="$t('order_limit_hint')"
                  :label="$t('order_limit')"
                  outlined
                  type="number"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-tempContent-order_limit`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('order_limit')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12" lg="4" md="6">
              <div class="rowinfo">
                <price-input
                  v-model.number="tempContent.packing_price"
                  class="mb-2 contentinfo"
                  clear-icon="mdi-close-circle-outline"
                  clearable
                  dense
                  :hint="$t('packing_price_hint')"
                  :label="$t('packing_price')"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-tempContent-packing_price`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('packing_price')"
                />
              </div>
            </v-col>

            <v-col class="pa-2" cols="12">
              <div class="rowinfo" style="width: 100%">
                <suggest-text
                  v-model="tempContent.description"
                  :hide-details="false"
                  class="contentinfo"
                  :label="$t('description')"
                />
                <help-info
                  :element-name="`${serviceName}-${componentName}-tempContent-description`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  :label="$t('description')"
                />
              </div>
            </v-col>
          </v-row>

          <v-divider />
          <div class="extra-wrapper">
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div
                    class="pa-2 d-flex row justify-start"
                    style="align-items: center"
                  >
                    {{ $t("options") }}
                    <help-info
                      :element-name="`${serviceName}-${componentName}-add-options`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('options')"
                    />
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-0">
                  <product-option-editor
                    v-model="tempContent.options"
                    key="$i18n.locale"
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>

              <v-expansion-panel class="mt-4">
                <v-expansion-panel-header>
                  <div
                    class="pa-2 d-flex row justify-start"
                    style="align-items: center"
                  >
                    {{ $t("product_features") }}
                    <help-info
                      :element-name="`${serviceName}-${componentName}-add-features`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      :label="$t('product_features')"
                    />
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="pa-2">
                  <extra-fileds
                    v-model="tempContent.extra"
                    style="width: 100%"
                    block
                  />
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>
        </v-card-text>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import ColorPallete from "@/view/components/colorPallete";
import PicSelector from "@/view/components/UploadCenter/picSelector";
import PicSelectorSingle from "@/view/components/UploadCenter/picSelectorSingle";
import IconPicker from "@/view/components/IconPicker";
import PriceInput from "@/view/pages/uiBeautifier/priceInput";
import SuggestText from "@/view/components/SuggestBox/suggestInput";
import ExtraFileds from "./extraFileds";
import CallToAction from "@/view/components/CallToAction";
import { mapGetters } from "vuex";
import ExtraSubProducts from "@/view/components/Product/extraSubProducts.vue";
import ProductOptionEditor from "@/view/components/Product/productOptionEditor.vue";

export default {
  name: "ProductEditor",

  components: {
    ProductOptionEditor,
    ExtraSubProducts,
    CallToAction,
    ExtraFileds,
    SuggestText,
    PriceInput,
    IconPicker,
    PicSelectorSingle,
    PicSelector,
    ColorPallete,
  },

  props: {
    value: Object,
    onlineShop: Boolean,
    hasReturn: {
      type: Boolean,
      default: true,
    },
    newData: {
      type: Number,
      default: 0,
    },
    category: Object,
  },

  inject: ["productImageSize"],

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "product-editor",
      openSetting: false,
      tabs: 0,
      tempContent: {},
      loading: false,
      status: "return",
    };
  },

  mounted() {
    this.getData();
  },

  computed: {
    ...mapGetters("localstorage", ["createQrID"]),
    discountRules() {
      return [
        (v) => {
          // Convert input to English digits for validation
          const cleanedValue = this.english((v || "").replace(/,/g, ""));
          const numericValue = parseFloat(cleanedValue) || 0;

          if (this.tempContent.discount_type === "percent") {
            // For percentage, value must be between 0 and 100
            return (
              (numericValue >= 0 && numericValue <= 100) ||
              this.$t("discount_percent_range")
            );
          } else {
            // For price, value must be less than or equal to tempContent.price
            const maxPrice = parseFloat(this.tempContent.price) || 0;
            return (
              (numericValue >= 0 && numericValue <= maxPrice) ||
              this.$t("discount_price_range", { max: this.price(maxPrice) })
            );
          }
        },
        (v) => /^[۰-۹٠-٩0-9,]+$/.test(v || "") || this.$t("invalid_number"),
      ];
    },
    computedtempContentdiscount: {
      get() {
        // Format the discount for display
        const value = this.tempContent.discount ?? 0;
        return this.use_lang(this.price(value));
      },
      set(value) {
        // Parse the input value back to a number
        let cleanedValue = value;
        cleanedValue = this.english(cleanedValue.replace(/,/g, ""));
        this.$set(this.tempContent, "discount", parseFloat(cleanedValue) || 0);
      },
    },
    currencyIcon() {
      switch (this.$i18n.locale) {
        case "fa":
          return "mdi-currency-rial";
        case "en":
          return "mdi-currency-usd";
        case "ar":
          return "mdi-currency-iqd"; // Iraqi Dinar
        default:
          return "mdi-currency-usd";
      }
    },
    rules() {
      return {
        notEmpty: (v) => !!v?.length || this.$t("field_required"),
        minLen: (v) => v?.length >= 3 || this.$t("min_length"),
      };
    },
    computedTabItems() {
      const tabs2 = [];

      if (this.$route.name !== "qr.product.shop")
        tabs2.push({
          text: this.$t("image"),
          icon: "image",
          value: "image",
        });
      if (
        this.$route.name !== "qr.product.shop" &&
        this.$route.name !== "qr.create.businessPage"
      )
        tabs2.push({
          text: this.$t("color"),
          icon: "palette",
          value: "color",
          disabled: true,
        });
      return tabs2;
    },
    computeValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedFields() {
      return { ...this.tempContent.children, ...this.tempContent.options };
    },
    proxyVal() {
      return new Proxy(this.computedFields, {
        get(tar, prop) {
          return tar[prop];
        },
        set(tar, prop, val) {
          tar[prop] = val;
          return true;
        },
      });
    },
    isModelList() {
      return this.$route.name.toLowerCase().includes("model");
    },
  },

  watch: {
    newData() {
      this.getData();
    },
    "$i18n.locale": {
      handler() {
        this.getData();
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },

  methods: {
    resetOther(product, name) {
      const current = product[name];

      product.gallery = [{ name: "", images: [] }];
      product.color = undefined;
      product.icon = undefined;

      product[name] = current;
    },
    submitNewProduct() {
      this.loading = true;

      const { transliterate } = require("transliteration");

      function slugify(str) {
        return transliterate(str)
          .toLowerCase()
          .trim()
          .replace(/[\s\W-]+/g, "-") // Replace spaces and non-word characters with a hyphen
          .replace(/^-+|-+$/g, ""); // Remove leading and trailing hyphens
      }

      let obj = {
        ...this.tempContent,
        gallery:
          typeof this.tempContent.gallery === "string"
            ? this.tempContent.gallery
            : JSON.stringify(this.tempContent.gallery),
        status: "active",
        qr_id: this.createQrID,
        category_id: this.category.id,
        slug: slugify(this.tempContent.name + " " + this.tempContent.price),
        discount_type:
          this.tempContent.discount_type === "price" ? "price" : "percent",
        discount_amount: this.english(this.computedtempContentdiscount),
        details: JSON.stringify(this.tempContent.extra),
        quantity: this.tempContent.quantity || null,
      };

      if (this.isModelList) {
        this.$emit("input", obj);
        return;
      }

      const formData = new FormData();
      formData.append("products", JSON.stringify([obj]));
      this.$api
        .post("/v1/testQr/product", formData, {
          timeout: 100000,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(({ data }) => {
          this.$toast.success(this.$t("product_added_success"));
          this.$emit("saved", {
            ...data.data[0],
            options: fixOptions(data.data[0].options),
          });

          function fixOptions(options) {
            const src = {
              inventory: "",
              max_order: "",
              price: 0,
              discount: 0,
              id: null,
            };

            return options.reduce((obj, curr) => {
              let target = JSON.parse(JSON.stringify(src));

              for (const key in target) {
                if (curr.hasOwnProperty(key)) {
                  target[key] = curr[key];
                }
              }

              if (curr.type === "color")
                target = {
                  ...target,
                  color: curr.value,
                  color_name: curr.name,
                };
              else
                target = {
                  ...target,
                  size: curr.value,
                };

              if (obj[curr.type]) obj[curr.type].push(target);
              else obj[curr.type] = [target];

              return obj;
            }, {});
          }
        })
        .catch(({ response }) => {
          this.$toast.error(this.$t("product_added_error"));
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getData(input = null) {
      let obj = input ?? this.value ?? {};

      const cleanAndParse = (obj) => ({
        ...obj,
        gallery:
          obj.gallery !== null && typeof obj.gallery === "string"
            ? JSON.parse(obj.gallery)
            : [
                {
                  name: null,
                  images: [],
                },
              ],
        extra: typeof obj.extra === "string" ? JSON.parse(obj.extra) : [],
      });

      const defaultContent = {
        parent_id: null,
        sub_type: null,
        qr_id: this.createQrID,
        category_id: this.category.id,
        name: this.$t("product"),
        slug: "",
        description: "",
        price: "0",
        discount_amount: null,
        discount_type: "percent",
        gallery: [{ name: "", images: [] }],
        brand: this.$t("default_brand"),
        inventory: null,
        order_limit: null,
        packing_price: 0,
        extra: [],
        default_option: null,
        status: "active",
        children: [],
        options: [],
      };

      this.tempContent = obj ? cleanAndParse(obj) : defaultContent;
    },
  },
};
</script>

<style scoped>
.v-card >>> input::-webkit-outer-spin-button,
.v-card >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
.v-card >>> input[type="number"] {
  -moz-appearance: textfield;
}

.v-radio >>> label {
  top: 3px !important;
}

.extra-wrapper >>> .v-expansion-panel {
  border-radius: 15px !important;
  box-shadow: 8px 5px 10px #f49d1a;
}

.extra-wrapper
  >>> .v-expansion-panel
  .v-expansion-panel-header.v-expansion-panel-header--active {
  background-color: #001554 !important;
  border-radius: 15px !important;
  color: gray !important;
}

.extra-wrapper
  >>> .v-expansion-panel
  .v-expansion-panel-header.v-expansion-panel-header--active
  .v-icon {
  color: whitesmoke !important;
}

.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0;
}
</style>
